module.exports = __webpack_public_path__ + "img/zoom3.8814f1c7.svg";